import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import { c as classNames } from '../shared/index-e39a0673.js';

function getSizingClassName(styles, width, height) {
  var isFixedWidth = width !== 'parent' && width !== 'content';
  var isFixedHeight = height !== 'parent' && height !== 'content';
  return classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles['width-parent'], width === 'parent'), styles['width-content'], width === 'content'), styles['width-custom'], isFixedWidth), styles['height-parent'], height === 'parent'), styles['height-content'], height === 'content'), styles['height-custom'], isFixedHeight));
}
function getSizingStyle(varPrefix, width, height) {
  if (!_trimInstanceProperty(varPrefix).call(varPrefix)) {
    return {};
  }
  var isFixedWidth = width !== 'parent' && width !== 'content';
  var isFixedHeight = height !== 'parent' && height !== 'content';
  return _objectSpread(_objectSpread({}, isFixedWidth && _defineProperty({}, "--".concat(varPrefix, "-width"), typeof width === 'number' ? "".concat(width, "px") : width)), isFixedHeight && _defineProperty({}, "--".concat(varPrefix, "-height"), typeof height === 'number' ? "".concat(height, "px") : height));
}

export { getSizingClassName, getSizingStyle };
//# sourceMappingURL=sizing.js.map
